<div
  *ngIf="form"
  [hidden]="!shouldVisibleFutureCheckBox"
  [formGroup]="form"
  class="custom-control custom-switch custom-switch-sm ml-3"
>
  <input class="custom-control-input" type="checkbox" id="future" formControlName="future" />
  <label class="custom-control-label custom-control-label-sm" for="future">{{ 'FUTURE' | translate }}</label>
</div>
